/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { TeamMemberDtoEdgeModel, TeamMemberDtoEdgeModelType } from "./TeamMemberDtoEdgeModel"
import { TeamMemberDtoEdgeModelSelector } from "./TeamMemberDtoEdgeModel.base"
import { TeamMemberDtoModel, TeamMemberDtoModelType } from "./TeamMemberDtoModel"
import { TeamMemberDtoModelSelector } from "./TeamMemberDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  nodes: IObservableArray<TeamMemberDtoModelType>;
}

/**
 * TeamMemberPaginatedDtoBase
 * auto generated base class for the model TeamMemberPaginatedDtoModel.
 */
export const TeamMemberPaginatedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('TeamMemberPaginatedDto')
  .props({
    __typename: types.optional(types.literal("TeamMemberPaginatedDto"), "TeamMemberPaginatedDto"),
    edges: types.union(types.undefined, types.null, types.array(types.late((): any => TeamMemberDtoEdgeModel))),
    nodes: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => TeamMemberDtoModel)))),
    totalCount: types.union(types.undefined, types.integer),
    hasNextPage: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class TeamMemberPaginatedDtoModelSelector extends QueryBuilder {
  get totalCount() { return this.__attr(`totalCount`) }
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  edges(builder: string | TeamMemberDtoEdgeModelSelector | ((selector: TeamMemberDtoEdgeModelSelector) => TeamMemberDtoEdgeModelSelector) | undefined) { return this.__child(`edges`, TeamMemberDtoEdgeModelSelector, builder) }
  nodes(builder: string | TeamMemberDtoModelSelector | ((selector: TeamMemberDtoModelSelector) => TeamMemberDtoModelSelector) | undefined) { return this.__child(`nodes`, TeamMemberDtoModelSelector, builder) }
}
export function selectFromTeamMemberPaginatedDto() {
  return new TeamMemberPaginatedDtoModelSelector()
}

export const teamMemberPaginatedDtoModelPrimitives = selectFromTeamMemberPaginatedDto().totalCount.hasNextPage
